import { useCallback, useState } from "react";

// Typed text kept in memory for this page load only (never stored). If the tool remounts after the
// page finishes loading (lazy chunk, usage check), text typed in the meantime is restored instead of
// being replaced by the example text.
const drafts = new Map<string, string>();

export function useTabDraft(key: string, initial: string): [string, (v: string) => void] {
  const [value, setValue] = useState(() => drafts.get(key) ?? initial);
  const set = useCallback((v: string) => { drafts.set(key, v); setValue(v); }, [key]);
  return [value, set];
}
